import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import Background from "../../../assets/welcome/background.webp";
import Background2x from "../../../assets/welcome/background@2x.webp";
import Background3x from "../../../assets/welcome/background@3x.webp";
import BackgroundMobile from "../../../assets/welcome/background-mobile.webp";
import BackgroundMobile2x from "../../../assets/welcome/background-mobile@2x.webp";
import BackgroundMobile3x from "../../../assets/welcome/background-mobile@3x.webp";
import BackgroundReward from "../../../assets/welcome/background-reward.webp";
import BackgroundReward2x from "../../../assets/welcome/background-reward@2x.webp";
import BackgroundReward3x from "../../../assets/welcome/background-reward@3x.webp";
import {
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

const bgImageDesktopSet = `-webkit-image-set(url(${Background}) 1x, url(${Background2x}) 2x, url(${Background3x}) 3x)`;
const bgImageMobileSet = `-webkit-image-set(url(${BackgroundMobile}) 1x, url(${BackgroundMobile2x}) 2x, url(${BackgroundMobile3x}) 3x)`;
const bgRewardDesktopSet = `-webkit-image-set(url(${BackgroundReward}) 1x, url(${BackgroundReward2x}) 2x, url(${BackgroundReward3x}) 3x)`;

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    backgroundImage: bgImageMobileSet,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    borderRadius: theme.radius.medium,
    border: "2px solid rgba(255, 255, 255, 0.27)",
    minWidth: 313,
    minHeight: 604,
    display: "flex",
    justifyContent: "center",
    "& > :last-child": {
      display: "none",
    },
    [BreakPointDesktop]: {
      minWidth: 1077,
      minHeight: 710,
    },
    "&.isDesktop": {
      backgroundImage: bgImageDesktopSet,
    },
    [BreakPointMobile]: {
      padding: 0,
      maxHeight: "calc(100dvh - 16px)",
      overflow: "hidden",
      "& > div": {
        flex: 1,
        minHeight: 0,
      },
      "@media (max-height: 640px)": {
        height: "calc(100dvh - 16px)",
      },
    },
  },
  rootReward: {
    "&.isDesktop": {
      backgroundImage: bgRewardDesktopSet,
    },
  },
  contentDialog: {
    gap: 0,
    textAlign: "left",
    width: `calc(100% - ${theme.spacing.space32}px)`,
    padding: `${theme.spacing.space16}px 0px`,
    [BreakPointMobile]: {
      textAlign: "center",
    },
    [BreakPointDesktop]: {
      width: "100%",
      marginLeft: theme.spacing.space8,
      padding: `0px ${theme.spacing.space32}px`,
    },
  },
  scrollContent: {
    [BreakPointMobile]: {
      flex: 1,
      minHeight: 0,
      overflowX: "hidden",
      overflowY: "auto",
      overscrollBehavior: "contain",
      WebkitOverflowScrolling: "touch",
    },
  },
  accessLabel: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space6,
    height: 33,
    width: 170,
    borderRadius: 33,
    background: "#166CD6",
    marginTop: theme.spacing.space4,
    "&.linearBg": {
      background: "linear-gradient(275deg, #4786D3 4.58%, #17529B 89.48%)",
    },
    [BreakPointDesktop]: {
      height: 40,
      width: 183,
      borderRadius: 40,
      fontWeight: 700,
    },
  },
  accessText: {
    fontWeight: "600 !important",
  },
  title: {
    fontSize: "32px !important",
    fontWeight: "700 !important",
    marginTop: theme.spacing.space20,
    lineHeight: "140% !important",
    [BreakPointDesktop]: {
      fontSize: "60px !important",
      marginTop: theme.spacing.space48,
      lineHeight: "120% !important",
    },
  },
  logo: {
    display: "block",
    maxWidth: "fit-content",
    aspectRatio: "114 / 42",
    height: 42,
    marginTop: theme.spacing.space8,
    [BreakPointMobile]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    [BreakPointDesktop]: {
      height: 66,
      aspectRatio: "180 / 66",
    },
  },
  card: {
    border: "1px solid #166CD6",
    padding: theme.spacing.space16,
    marginTop: theme.spacing.space20,
    marginBottom: theme.spacing.space20,
    borderRadius: theme.radius.small,
    display: "flex",
    gap: theme.spacing.space8,
    background: "#041E3E",
    textAlign: "left",
    [BreakPointDesktop]: {
      width: "35%",
    },
  },
  aiIcon: {
    color: "#166CD6",
  },
  subTitle: {
    marginTop: theme.spacing.space20,
    [BreakPointDesktop]: {
      marginTop: theme.spacing.space48,
    },
  },
  desc: {
    color: "#D1D1D1 !important",
  },
  goBtn: {
    background: "#166CD6",
    marginTop: theme.spacing.space24,
    height: 50,
    borderRadius: theme.radius.small,
    fontSize: 16,
    fontWeight: 600,
    "&.linearBg": {
      background: "linear-gradient(275deg, #4786D3 4.58%, #17529B 89.48%)",
    },
    [BreakPointDesktop]: {
      height: 57,
      fontSize: 20,
      marginTop: 60,
      paddingLeft: theme.spacing.space48,
      paddingRight: theme.spacing.space48,
    },
  },
  devices: {
    marginTop: theme.spacing.space20,
  },
  installText: {
    color: "#D1D1D1 !important",
  },
}));
